<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <article v-else>
            <!--eslint-disable-next-line vue/no-v-html-->
            <HeroSubsidy
                :title="entry?.title"
                :description="entry?.description"
                :periods-relation="entry?.periodsRelation"
                :help-cards="entry?.helpCards"
                :uri="entry?.uri"
            />

            <FlexibleSections
                v-if="entry.flexibleSections"
                id="content"
                :sections="entry.flexibleSections"
            />
        </article>
    </div>
</template>

<script setup>
import { useMainStore } from '~/stores/main.js';
import { formatISO } from 'date-fns';
import getSubsidyPage from '~/graphql/queries/getSubsidyPage.graphql';

defineI18nRoute({
    paths: {
        en: '/funding/fund/[subsidy]',
    }
});

const route = useRoute();

const { variables: defaultVariables }  = useCraftGraphql();

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });
    
    return {
        ...defaultVariables,
        uri: undefined, // We don't need the URI for this query
        section: 'subsidies',
        type: 'subsidy',
        slug: route.params.subsidy,
        now: ['or', `>= ${now}`, null]
    };
});

const response = await useAsyncQuery({
    query: getSubsidyPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);

const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry.value?.showNewsletterSubscribe ?? false);
});
</script>

